var _circle, _path, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoChallenge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF1FA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 22.4623C14.666 20.5685 16.2012 19.0333 18.0949 19.0333V19.0333C18.6436 19.0333 19.1395 18.7064 19.3556 18.2021L19.5193 17.82C19.9925 16.7159 21.0782 16 22.2795 16H23.3327H24.3859C25.5872 16 26.6728 16.7159 27.146 17.82L27.3098 18.2021C27.5259 18.7064 28.0218 19.0333 28.5704 19.0333V19.0333C30.4642 19.0333 31.9993 20.5685 31.9993 22.4623V27.1667C31.9993 29.3758 30.2085 31.1667 27.9993 31.1667H18.666C16.4569 31.1667 14.666 29.3758 14.666 27.1667V22.4623Z",
    stroke: "white",
    strokeWidth: 1.73333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.6,
    cy: 2.6,
    r: 2.6,
    transform: "matrix(-1 0 0 1 25.9336 21.6335)",
    stroke: "white",
    strokeWidth: 1.73333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoChallenge);
export default __webpack_public_path__ + "static/media/photo-challenge.aa7bcc62323d2a0482d97c1b7d7a1105.svg";
export { ForwardRef as ReactComponent };